
export enum SubAccountStatusId {
    Revoked = 0,
    Idle = -1,
    Active = 1
}